import { patternConstants } from "../../constants";
import { patternService } from "../../services";
import { alertActions } from "../alert.actions";

export const patternActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    patternService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: patternConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: patternConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: patternConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code, image, status, measurements, method, csv) {
  return (dispatch) => {
    dispatch(request(name, code, image, status, measurements, method, csv));

    patternService
      .addParameter(name, code, image, status, measurements, method, csv)
      .then(
        (parameter) => {
          dispatch(success(parameter));
          dispatch(alertActions.success(parameter));
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request(parameter) {
    return { type: patternConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: patternConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: patternConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code, image, status, measurements) {
  return (dispatch) => {
    dispatch(request(id, name, code, image, status, measurements));

    patternService
      .updateParameter(id, name, code, image, status, measurements)
      .then(
        (parameter) => {
          dispatch(success(parameter));
          dispatch(alertActions.success(parameter));
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request(parameter) {
    return { type: patternConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: patternConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: patternConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    patternService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: patternConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: patternConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: patternConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: patternConstants.CLEAR };
}
